import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ValueResponseDto } from '../dto/response/value-response.dto';
import { ValueSaveRequestDto } from '../dto/request/value-save-request.dto';
import { ValueUpdateRequestDto } from '../dto/request/value-update-request.dto';
import baselineService from '../services/baseline.service';
import { AxiosError } from 'axios';
import { showError, showSuccess } from '../../../../utils/Notifications';
const initialState = {
  status: 'idle',
  targets: [] as ValueResponseDto[] | null,
  target: {} as ValueResponseDto | null,
  error: null as string | null,
};

// export const fetchBaselineById = createAsyncThunk(
//   'baselines/fetchBaselineById',
//   async (id: string) => {
//     return await baselineService.fetchBaselineById(id);
//   }
// );

export const saveBaseline = createAsyncThunk(
  'baselines/saveBaseline',
  async (saveRequest: ValueSaveRequestDto, { rejectWithValue }) => {
    try {
      return await baselineService.saveBaseline(saveRequest);
    } catch (e) {
      return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
    }
  }
);

export const updateBaseline = createAsyncThunk(
  'baselines/updateBaseline',
  async (updateRequest: ValueUpdateRequestDto, { rejectWithValue }) => {
    try {
      return await baselineService.updateBaseline(updateRequest);
    } catch (e) {
      return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
    }
  }
);

// export const updateVerificationLabel = createAsyncThunk(
//   'baselines/updateVerificationLabel',
//   async (updateRequest: ValueUpdateRequestDto, { rejectWithValue }) => {
//     try {
//       return await baselineService.updateVerificationLabel(updateRequest);
//     } catch (e) {
//       return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
//     }
//   }
// );

// export const deleteBaseline = createAsyncThunk(
//   'baselines/deleteBaseline',
//   async (existingId: string, { rejectWithValue }) => {
//     try {
//       return await baselineService.deleteBaseline(existingId);
//     } catch (e) {
//       return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
//     }
//   }
// );

const baselineSlice = createSlice({
  name: 'baselineSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // .addCase(fetchBaselineById.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchBaselineById.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.target = action.payload;
      // })
      // .addCase(fetchBaselineById.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(saveBaseline.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveBaseline.fulfilled, (state, action) => {
        state.status = 'succeeded';
        showSuccess('Baseline added successfully.');
        state.targets?.push(action.payload);
      })
      .addCase(saveBaseline.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
        showError(`Saving baseline failed. ${action.payload as string}`);
      })
      .addCase(updateBaseline.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateBaseline.fulfilled, (state, action) => {
        state.status = 'succeeded';
        showSuccess('Baseline saved successfully.');
        if (state.targets) {
          const targetIndex = state.targets.findIndex(
            (target) => target.id === action.payload.id
          );
          if (targetIndex !== -1) {
            state.targets[targetIndex] = action.payload;
          }
        }
      })
      .addCase(updateBaseline.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
        showError(`Saving baseline failed. ${action.payload as string}`);
      });
    // .addCase(updateVerificationLabel.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(updateVerificationLabel.fulfilled, (state, action) => {
    //   state.status = 'succeeded';
    //   showSuccess('Verification label saved successfully.');
    //   if (state.targets) {
    //     const targetIndex = state.targets.findIndex(
    //       (target) => target.id === action.payload.id
    //     );
    //     if (targetIndex !== -1) {
    //       state.targets[targetIndex] = action.payload;
    //     }
    //   }
    // })
    // .addCase(updateVerificationLabel.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.payload as string;
    //   showError(
    //     `Saving verification label failed. ${action.payload as string}`
    //   );
    // })
    // .addCase(deleteBaseline.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(deleteBaseline.fulfilled, (state) => {
    //   state.status = 'succeeded';
    //   showSuccess('Baseline deleted successfully.');
    // })
    // .addCase(deleteBaseline.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.payload as string;
    //   showError(`Deleting baseline failed. ${action.payload as string}`);
    // });
  },
});

export default baselineSlice.reducer;
